import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useProfileLocaleSync } from '../i18n';
import { useTheme } from '../theme/ThemeProvider';
import { AppHeader } from './AppHeader';
import { MobileOverflowSheet } from './MobileOverflowSheet';
import { MobileTabBar } from './MobileTabBar';
import { Sidebar } from './Sidebar';

/**
 * App chrome — Ghost Screen - Home.dc.html shell on every route:
 * white L-frame (sidebar + header, no join divider) and one inset content
 * well (canvas) with top + left hairlines and a 24px top-left radius.
 */
export function AppShell() {
  const { theme } = useTheme();
  const { pathname } = useLocation();
  const [overflowOpen, setOverflowOpen] = useState(false);
  useProfileLocaleSync();

  useEffect(() => {
    setOverflowOpen(false);
  }, [pathname]);

  useEffect(() => {
    if (!overflowOpen) return;
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previous;
    };
  }, [overflowOpen]);

  return (
    <div
      data-theme={theme}
      className="flex h-dvh overflow-hidden font-sans"
      style={{
        background: 'var(--gs-panel)',
        color: 'var(--gs-ink)',
      }}
    >
      <Sidebar />

      <div
        className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden"
        style={{ background: 'var(--gs-panel)' }}
      >
        <AppHeader
          overflowOpen={overflowOpen}
          onOpenOverflow={() => setOverflowOpen(true)}
        />

        {/* Inset content well — same chrome for every page under AppShell. */}
        <div
          className="flex min-h-0 flex-1 flex-col overflow-hidden lg:overflow-clip lg:rounded-ss-[24px] lg:border-s lg:border-t"
          style={{
            background: 'var(--gs-canvas)',
            borderColor: 'var(--gs-line)',
          }}
        >
          <main className="flex min-h-0 flex-1 flex-col gap-5 overflow-y-auto overscroll-contain px-4 py-4 sm:gap-[26px] sm:px-[clamp(18px,2.4vw,32px)] sm:py-5">
            <Outlet />
          </main>
          <MobileTabBar />
        </div>
      </div>

      <MobileOverflowSheet open={overflowOpen} onClose={() => setOverflowOpen(false)} />
    </div>
  );
}
